/** @typedef {import('../index.js').InvalidDocData} InvalidDocData */
/** @typedef {import('./organization.js').OrganizationDocData} OrganizationDocData */
import Organization from './organization.js';

/**
 * Converts a Firestore document snapshot into an {@link Organization} instance.
 * @param {any} doc Raw Firestore document snapshot.
 * @returns A {@link Organization} instance.
 */
function orgFromFirestore(doc) {
  const docData = { id: doc.id, ...doc.data() };
  try {
    return Organization.fromFirestore(docData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error transforming organization data:', docData.id, error);
    /** @type {InvalidDocData} */
    const InvalidDocData = { validation: 'failed', ...docData };
    return InvalidDocData;
  }
}

/**
 * Converts a {@link Organization} instance into a Firestore-compatible object.
 * @param {Organization} org A {@link Organization} instance.
 * @returns A {@link OrganizationDocData} object (without `id`).
 */
function orgToFirestore(org, serverTimestamp) {
  if (!serverTimestamp) {
    throw new Error('Missing serverTimestamp function');
  }
  return new Organization(org).toFirestore({ serverTimestamp });
}

export {
  orgFromFirestore,
  orgToFirestore,
};
